import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class ClientRecordService {
  constructor(private http: HttpClientService) {}

  public getAllRecords({ process = undefined, search = "", page = undefined, page_size = undefined }) {
    const options = {
      params: {
        process,
        search,
        page,
        page_size,
      },
    };
    return this.http
      .get("/api/client_records", options)
      .pipe(tap((_) => console.log("ClientRecordService.getAllRecords: Ok.")));
  }

  public forwardProcess(id: number, step) {
    return this.http
      .post(`/api/client_records/${id}/forward_process`, { step })
      .pipe(tap((_) => console.log("ClientRecordService.forwardProcess: Ok.")));
  }

  public updateClientRecord(id, data): Observable<any> {
    return this.http
      .put(`/api/client_records/${id}`, data)
      .pipe(tap((_) => console.log("ClientRecordService.updateClientRecord: Ok.")));
  }

  public checkStatus(date) {
    return this.http
      .post(`/api/client_records/check_status`, { date })
      .pipe(tap((_) => console.log("ClientRecordService.checkStatus: Ok.")));
  }

  public resendDocument(clientRecordId: number, documentId: number): Observable<ResendDocumentResponse> {
    return this.http
      .post(`/api/client_records/${clientRecordId}/resend_document/${documentId}`, {})
      .pipe(tap((_) => console.log("ClientRecordService.resendDocument: Ok.")));
  }
}

export interface ResendDocumentResponse {
  success: boolean;
  message: string;
  error_code?: string;
  error_description?: string;
}
